var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { breakpoints } from '@local/styleguide';
import { core } from '../../../charts';
import { HtmlLegendCustom } from '../../shared/html/html-legend-custom';
import { ChartBarProgression } from '../../../charts/elements/chart-bar-progression';
const graphHeight = 420;
const barHeight = 32;
export class RevenueBarsV1 extends core.GraphControllerV3 {
    constructor(slug, page, group, mapping, segment, index) {
        super(slug, page, group, mapping, segment);
        this.slug = slug;
        this.page = page;
        this.group = group;
        this.mapping = mapping;
        this.segment = segment;
        this.index = index;
        this.bars = {};
        this.companies = {};
        this.entity_svgs = {};
        this.ctrlrs = {};
        this.pre();
    }
    pre() {
        const bottom = window.innerWidth < breakpoints.sm ? 170 : 100;
        this._addMargin(60, bottom, 0, 0);
        this._addPadding(0, 0, 60, 0);
        this._addScale('x', 'band', 'horizontal', 'year');
        this._addScale('y', 'linear', 'vertical', 'value');
        this._addAxis('x', 'x', 'bottom');
        this._addAxis('y', 'y', 'left', 'millions');
    }
    html() {
        if (this.group.element == null)
            return;
        // this.group.element.style.minWidth = "600px";
        this.graphEl = super._html();
        if (this.graphEl != null)
            this.graphEl.style.height = (window.innerWidth < breakpoints.sm) ? graphHeight.toString() + "px" : graphHeight.toString() + "px";
    }
    init() {
        const _super = Object.create(null, {
            _init: { get: () => super._init },
            _svg: { get: () => super._svg }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this.config.paddingInner = .2;
            this.config.paddingOuter = .2;
            yield _super._init.call(this);
            if (this.graphEl != null)
                yield _super._svg.call(this, this.graphEl);
            this.legend = new HtmlLegendCustom(this.graphEl);
            this.chartBar = new ChartBarProgression(this);
            yield this.update(this.group.data, this.segment, false);
            return;
        });
    }
    prepareData(data) {
        return data;
    }
    draw(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.chartBar.draw(data.graph);
            // replace with call to api_defintions and thgen splice the array for relevant payment types
            if (this.mapping.slug == 'betalingen_bedrijven') {
                this.legend.draw([
                    {
                        label: this.page.main.params.language == 'en' ? "Royalties" : "Cijns",
                        colour: "purple"
                    },
                    {
                        label: this.page.main.params.language == 'en' ? "Surface rental" : "Oppervlakterecht",
                        colour: "lightBlue"
                    },
                    {
                        label: this.page.main.params.language == 'en' ? "Retributions" : "Retributies",
                        colour: "gray"
                    }
                ]);
            }
            else {
                this.legend.draw([
                    {
                        label: this.page.main.params.language == 'en' ? "Dividends" : "Dividenden",
                        colour: "green"
                    },
                    {
                        label: this.page.main.params.language == 'en' ? "Extra Income Scheme (MOR)" : "Meeropbrengstregeling",
                        colour: "violet"
                    },
                    {
                        label: this.page.main.params.language == 'en' ? "Corporate Income Tax" : "Vennootschapsbelasting",
                        colour: "blue"
                    },
                    {
                        label: this.page.main.params.language == 'en' ? "Profit share" : "Winstaandeel",
                        colour: "orange"
                    },
                    {
                        label: this.page.main.params.language == 'en' ? "Royalties" : "Cijns",
                        colour: "purple"
                    },
                    {
                        label: this.page.main.params.language == 'en' ? "Surface rental" : "Oppervlakterecht",
                        colour: "lightBlue"
                    },
                    {
                        label: this.page.main.params.language == 'en' ? "Retributions" : "Retributies",
                        colour: "gray"
                    },
                    {
                        label: this.page.main.params.language == 'en' ? "State Share" : "Staatsaandeel",
                        colour: "brown"
                    },
                    {
                        label: this.page.main.params.language == 'en' ? "Solidarity Contribution" : "Solidariteitsbijdrage",
                        colour: "violet"
                    }
                ]);
            }
        });
    }
    redraw(data, range) {
        const _super = Object.create(null, {
            redraw: { get: () => super.redraw }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this.scales.x.set(data.graph.map(d => d.year));
            this.scales.y.set(data.graph.map(d => d.y + d.dy));
            yield _super.redraw.call(this, data.graph);
            this.chartBar.redraw(this.dimensions);
        });
    }
    update(data, segment, update, range) {
        const _super = Object.create(null, {
            _update: { get: () => super._update }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super._update.call(this, data, segment, update, range);
        });
    }
}
